<template>
  <el-select
    :value="value"
    @input="change"
    filterable
    clearable
    placeholder="请选择区域公司">
    <el-option
      v-for="item in regions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    props:['value'],
    computed:{
      ...mapGetters('decision',{
        regions:'selectRegionArr'
      })
    },
    created() {
      if(this.regions.length > 0){
        this.$emit('input', this.regions[0].value)
        this.$emit('change', this.regions[0].value)
      }else {
        this.$store.dispatch('decision/getMyRegion')
      }
    },
    mounted() {
      
    },
    watch: {
      regions:function(){
        if(this.regions.length > 0){
          this.$emit('input', this.regions[0].value)
          this.$emit('change', this.regions[0].value)
        }else {
          this.$emit('input', '')
          this.$emit('change', '')
        }
      }
    },
    methods: {
      change(value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>